import PurchaseTrainingForm from './PurchaseTrainingForm.vue';

export default PurchaseTrainingForm;
